import React from "react";
import ChangePass from "../../components/user/changePassword";
import Layout from "../../components/layouts/verticalLayout";

const ChangePassPage = ({ first }) => {
  return (
    <Layout
      body={
        <>
          <ChangePass isFirst={first || false} />
        </>
      }
    />
  );
};

ChangePassPage.propTypes = {};

export default ChangePassPage;
